import { ClientDataService, IClientDataDoc } from '../../../../services/clientData.service'

export class DrainService extends ClientDataService {
  private ACTION_DOC = 'drainaction_tb_prprocedure_action'
  private PROCEDURE_DOC = 'tb_drain_chest_action'
  private SIZE_UNIT_DOC = 'tb_needle_size_unit'
  private DRAIN_SUCTION_DOC = 'tb_prng_suction'
  private CHEST_SUCTION_DOC = 'tb_prchest_tube_suction'
  private FOLEY_COLOR_DOC = 'tb_prfoley_color'
  private CSF_COLOR_DOC = 'tb_prtube_csfcolor'
  private SIDE_DOC = 'tb_util_side'
  private ILEOSTOMY_COLOSTOMY_OPTIONS_DOC = 'tb_present-custom'
  private LOCATION_DOC = 'tb_drain_location'
  private INTERCOSTAL_SPACE_DOC = 'tb_intercostal_space'

  async getActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTION_DOC)
  }

  async getProcedureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PROCEDURE_DOC)
  }

  async getSizeUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIZE_UNIT_DOC)
  }

  async getDrainSuctionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DRAIN_SUCTION_DOC)
  }

  async getChestSuctionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CHEST_SUCTION_DOC)
  }

  async getFoleyColorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FOLEY_COLOR_DOC)
  }

  async getcsfColorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CSF_COLOR_DOC)
  }

  async getSideOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SIDE_DOC)
  }

  async getIleostomyColostomyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ILEOSTOMY_COLOSTOMY_OPTIONS_DOC)
  }

  async getLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LOCATION_DOC)
  }

  async getIntercostalSpaceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INTERCOSTAL_SPACE_DOC)
  }
}
